<template lang="pug">
.card-container(:class='colors')
  span.soon 敬请期待...
</template>

<script>

export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    colors() {
      return this.active ? 'bike' : 'moped';
    },
  },
};
</script>

<style lang="less" scoped>
.bike {
  background-image: url('https://m.hellobike.com/resource/AppPlatformH5/card-for-app/m5M7NcFjPQH1Gb4R1YXxO.png');
}

.moped {
  background-image: url('https://m.hellobike.com/resource/AppPlatformH5/card-for-app/GmcRBZTKnzq85Wytq7hYO.png');
}

.card-container {
  width: 1.46rem;
  height: 1.26rem;
  background-color: #fff;
  padding-top: 0.39rem;
  box-sizing: border-box;
  text-align: center;
  background-size: 100%;

  .soon {
    font-size: 0.13rem;
    font-weight: 400;
    color: #879099;
    line-height: 0.18rem;
  }
}
</style>
